import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import 'antd/dist/antd.css'
import { BrowserRouter } from 'react-router-dom'

import Routes from './routes'
 import rootReducer from './store/reducers'
import * as serviceWorker from './serviceWorker'

let store = createStore(rootReducer);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routes />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root'));
serviceWorker.register();